import { render, staticRenderFns } from "./PreRegister.vue?vue&type=template&id=6daf64de&scoped=true"
import script from "./PreRegister.vue?vue&type=script&lang=js"
export * from "./PreRegister.vue?vue&type=script&lang=js"
import style0 from "./PreRegister.vue?vue&type=style&index=0&id=6daf64de&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daf64de",
  null
  
)

export default component.exports